import React from 'react';
import { WorkflowWrapper } from '../../../Workflow/Workflow.styles';
import { Card } from '../../../CommonComponents/OPL/Card/Card';
import { ProfileWrapper } from '../../Profile.styles';
import { Box } from '../../../CommonComponents/OPL/Box/Box';

interface Props {
  isWorkflow: boolean;
  hasStickyFooter?: boolean;
  children: React.ReactNode;
}

export const Wrapper = ({ isWorkflow, hasStickyFooter, children }: Props) => {
  if (isWorkflow) {
    return (
      <WorkflowWrapper>
        <Card p="32">{children}</Card>
      </WorkflowWrapper>
    );
  }

  return (
    <Box css="overflow-x: auto">
      <ProfileWrapper hasStickyFooter={hasStickyFooter}>{children}</ProfileWrapper>
    </Box>
  );
};
